/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Service_PackInputs */

const en_start_page_service_pack = /** @type {(inputs: Start_Page_Service_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 × 60 min`)
};

const pl_start_page_service_pack = /** @type {(inputs: Start_Page_Service_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 × 60 min`)
};

/**
* | output |
* | --- |
* | "10 × 60 min" |
*
* @param {Start_Page_Service_PackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_service_pack = /** @type {((inputs?: Start_Page_Service_PackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Service_PackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_service_pack(inputs)
	return en_start_page_service_pack(inputs)
});